const {h, render, Component} = require('preact');
const queryString = require('qs');
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const Search = require('./search')
const SearchResults = require('./search_results')
const SpinnerView = require('../../views/common/spinner')
const ErrorView = require('../main/error')
const Helper = require('./helper')
const {route} = require('preact-router')
const SessionHelper = require('../../../helper')

class ContextualSearchBarPage extends Component {
  constructor(props) {
    super(props);
    this.handleNeedHelpFromSearchResults = this.handleNeedHelpFromSearchResults.bind(this)
  }

  componentDidMount() {
    this.handleSearch()
    this.setState({searchText: undefined, contextualSearchResults: null})
  }

  handleNeedHelpFromSearchResults(selectedInbentaResult){
    selectedInbentaResult = _.omit(selectedInbentaResult, 'answer', 'bloodhoundTracking')
    let orderSummaryParams = {
        selectedInbentaResult: selectedInbentaResult,
        showContactChannelsFromContextualBar: true,
        order_id : this.props.orderId
    }
    let claimSummaryParams = {
      selectedInbentaResult: selectedInbentaResult,
      showContactChannelsFromContextualBar: true,
      claimId: this.props.claimId
    }

    let qsOrderSummary = queryString.stringify(orderSummaryParams)
    let qsclaimSummary = queryString.stringify(claimSummaryParams)

    if (this.props.orderId) {
      route(`/customer_support/web/contact_channels?${qsOrderSummary}`);
    }
    else {
      route(`/customer_support/web/gplus/contact_channels?${qsclaimSummary}`);
    }
  }

  handleSearch(searchText){
    let resultParams = queryString.parse(this.props)
    let inbentaParams = Groupon.inbentaParams
    inbentaParams.query = resultParams.searchText

    if (searchText) {
      inbentaParams.query = searchText
    }

    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')

    if (inbentaSessionToken !== null && inbentaSessionToken != undefined) {
      inbentaParams.inbentaSessionToken = inbentaSessionToken
    }
    else {
      SessionHelper.createSession()
    }

    let qs = queryString.stringify(inbentaParams)
    let CONTEXTUAL_SEARCH = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/contextual_search?${qs}`;
    let errorCb = () => {
      this.setState({contextualSearchResults: null, isSearching: false, 'isFailure': true});
    }
    let successCb = (response) => {
      if(response)
      {
        this.setState({contextualSearchResults: response, searchText: inbentaParams.query, isSearching: false});
      }
    }
    this.setState({contextualSearchResults: null, isSearching: true})
    SupportAPIHelper.get(CONTEXTUAL_SEARCH, null, successCb, errorCb, false);
  }

  render() {
    let searchResultsComponent = null;
    Helper.closeOpenedArticles();

    if (this.state.contextualSearchResults) {
      searchResultsComponent = <SearchResults
          results={this.state.contextualSearchResults}
          searchText={this.state.searchText} handleNeedHelpFromSearchResults={this.handleNeedHelpFromSearchResults}
      />;
    }
    if (this.state.isFailure)
      return (<ErrorView/>)
    return (
        <section className="main row cs_support_header" id="contact-us-body-content">
          <div className="twelve columns">
            <section className="module">
              <div className="module-body contact-us">
                <div className="row">
                  <div id="help-wizard" className="help-wizard" style="display: block;">
                    <div className="help-wizard-content">
                      <div>
                        <div className="twelve columns order-summary summary-padding">
                          <div className="row">
                            <div>
                              <p className="contextual-search-bar-above-text">
                                {I18n.translate("js.modules.web_2018.need_help_with_this_groupon")}
                              </p>
                              <Search handleSearch={this.handleSearch.bind(this)}/>
                              {searchResultsComponent}
                              {this.state.isSearching && <SpinnerView/>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
    )
  }
}

module.exports = ContextualSearchBarPage
